export var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
export var calcTextFieldActionSubjectId = function calcTextFieldActionSubjectId(name) {
  return "stripeCreditCard".concat(capitalizeFirstLetter(name), "TextField");
};